import "../components/Footer.css"


function Footer() {
  return (
    <div className="footer">
      <h6>graze app 2021  af</h6>
    </div>
  )
}

export default Footer